import { memo, ReactNode } from 'react';
import { Sidebar } from '@/components/layout/Sidebar';
import { MobileLayout } from '@/components/mobile/MobileLayout';
import { useDashboardLayout } from '@/hooks/useDashboardLayout';

interface DashboardLayoutProps {
  children: ReactNode;
}

export const DashboardLayout = memo<DashboardLayoutProps>(({ children }) => {
  const {
    dockMode,
    isMobile,
    sidebarVisible,
    effectiveCollapsed,
    layoutStyles,
    handleSidebarToggle,
    handleMouseEnter,
    handleMouseLeave,
    toggleDockMode
  } = useDashboardLayout();

  if (isMobile) {
    return <MobileLayout />;
  }

  return (
    <div className="dark h-screen bg-background relative overflow-hidden flex">
      {dockMode === 'undocked' && !isMobile && (
        <div
          className="fixed left-0 top-0 w-2 h-full z-40 bg-transparent"
          onMouseEnter={handleMouseEnter}
        />
      )}

      <div
        className={`transition-transform duration-200 ease-out ${
          dockMode === 'undocked' && !sidebarVisible ? '-translate-x-full' : 'translate-x-0'
        }`}
        style={layoutStyles.sidebarContainer}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Sidebar
          collapsed={effectiveCollapsed}
          onToggle={handleSidebarToggle}
          dockMode={dockMode}
          onDockToggle={toggleDockMode}
          autoHideEnabled={dockMode === 'undocked'}
        />
      </div>

      <div
        className="flex-1 min-w-0 flex flex-col transition-all duration-200 ease-out"
        style={layoutStyles.contentContainer}
      >
        <div
          data-scroll-root
          className="flex-1 overflow-y-auto overflow-x-hidden min-h-0"
          style={layoutStyles.contentInner}
        >
          {children}
        </div>
      </div>
    </div>
  );
});

DashboardLayout.displayName = 'DashboardLayout';
